(function () {
  if (window.MuheyyInfiniteScrollProducts) return;
  window.MuheyyInfiniteScrollProducts = true;

  var ROOT_SELECTOR = '.collection-content[data-section-type="collection-grid"], .search-content[data-section-type="collection-grid"]';
  var GRID_SELECTOR = '.grid__item--content .collection-grid__wrapper > .grid.grid--uniform';
  var scanScheduled = false;

  function pageSignature(url) {
    var parsed = new URL(url, window.location.origin);
    parsed.searchParams.delete('page');
    return parsed.pathname + '?' + parsed.searchParams.toString();
  }

  function addStyles() {
    if (document.getElementById('muheyya-infinite-scroll-styles')) return;
    var style = document.createElement('style');
    style.id = 'muheyya-infinite-scroll-styles';
    style.textContent =
      '.muheyya-infinite-scroll-status{display:flex;align-items:center;justify-content:center;min-height:80px;width:100%;padding:20px 0;color:inherit;text-align:center;}' +
      '.muheyya-infinite-scroll-status[hidden]{display:none!important;}' +
      '.muheyya-infinite-scroll-spinner{width:26px;height:26px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:muheyyaInfiniteSpin .75s linear infinite;}' +
      '.muheyya-infinite-scroll-retry{padding:10px 18px;border:1px solid currentColor;background:transparent;color:inherit;cursor:pointer;}' +
      '@keyframes muheyyaInfiniteSpin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);
  }

  function reinitializeThemeCards() {
    if (!window.theme) return;
    if (typeof window.theme.reinitProductGridItem === 'function') {
      window.theme.reinitProductGridItem();
    }
    if (typeof window.theme.initQuickShop === 'function') {
      window.theme.initQuickShop();
    }
  }

  function initialize(root) {
    if (!root) return;

    var pagination = root.querySelector('.pagination');
    var nextLink = pagination && pagination.querySelector('.next a');
    var grid = root.querySelector(GRID_SELECTOR);
    var currentState = root._muheyyaInfiniteScrollState;

    if (currentState && currentState.pagination === pagination && currentState.grid === grid) return;
    if (currentState && typeof currentState.destroy === 'function') currentState.destroy();
    root.querySelectorAll('.muheyya-infinite-scroll-status').forEach(function (orphan) {
      orphan.remove();
    });
    root.removeAttribute('data-infinite-scroll-initialized');

    if (!pagination || !nextLink || !grid || !('IntersectionObserver' in window)) return;

    root.dataset.infiniteScrollInitialized = 'true';
    pagination.hidden = true;

    var status = document.createElement('div');
    status.className = 'muheyya-infinite-scroll-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.innerHTML = '<span class="muheyya-infinite-scroll-spinner" aria-hidden="true"></span><span class="visually-hidden">Daha fazla ürün yükleniyor</span>';
    pagination.parentNode.insertBefore(status, pagination);

    var nextUrl = nextLink.href;
    var loading = false;
    var finished = false;
    var initialSignature = pageSignature(window.location.href);
    var controller = 'AbortController' in window ? new AbortController() : null;
    var rootSelector = root.classList.contains('search-content')
      ? '.search-content[data-section-type="collection-grid"]'
      : '.collection-content[data-section-type="collection-grid"]';

    function finish() {
      finished = true;
      observer.disconnect();
      status.remove();
      pagination.remove();
      root.removeAttribute('data-infinite-scroll-initialized');
      if (root._muheyyaInfiniteScrollState && root._muheyyaInfiniteScrollState.pagination === pagination) {
        delete root._muheyyaInfiniteScrollState;
      }
    }

    function showError() {
      loading = false;
      status.innerHTML = '<button type="button" class="muheyya-infinite-scroll-retry">Ürünler yüklenemedi — tekrar dene</button>';
      var retry = status.querySelector('button');
      if (retry) retry.addEventListener('click', loadNextPage, { once: true });
      pagination.hidden = false;
    }

    function loadNextPage() {
      if (loading || finished || !nextUrl || !root.isConnected) return;
      loading = true;
      pagination.hidden = true;
      status.innerHTML = '<span class="muheyya-infinite-scroll-spinner" aria-hidden="true"></span><span class="visually-hidden">Daha fazla ürün yükleniyor</span>';

      var fetchOptions = {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      };
      if (controller) fetchOptions.signal = controller.signal;

      fetch(nextUrl, fetchOptions)
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          if (
            !root.isConnected ||
            root._muheyyaInfiniteScrollState !== state ||
            pageSignature(window.location.href) !== initialSignature
          ) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incomingRoot = doc.querySelector(rootSelector);
          var incomingGrid = incomingRoot && incomingRoot.querySelector(GRID_SELECTOR);
          if (!incomingGrid) throw new Error('Ürün ızgarası bulunamadı');

          var items = Array.prototype.slice.call(incomingGrid.children);
          items.forEach(function (item) {
            grid.appendChild(item);
          });

          var incomingNext = incomingRoot.querySelector('.pagination .next a');
          nextUrl = incomingNext ? incomingNext.href : null;
          loading = false;

          reinitializeThemeCards();
          document.dispatchEvent(new CustomEvent('infinite-scroll:loaded', {
            detail: { root: root, loadedCount: items.length }
          }));

          if (!nextUrl || items.length === 0) {
            finish();
          } else if (status.getBoundingClientRect().top < window.innerHeight + 600) {
            loadNextPage();
          }
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (root.isConnected && root._muheyyaInfiniteScrollState === state) showError();
        });
    }

    var observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) {
        loadNextPage();
      }
    }, { rootMargin: '600px 0px' });

    var state = {
      pagination: pagination,
      grid: grid,
      destroy: function () {
        observer.disconnect();
        if (controller) controller.abort();
        if (status.isConnected) status.remove();
        if (pagination.isConnected) pagination.hidden = false;
        if (root._muheyyaInfiniteScrollState === state) {
          delete root._muheyyaInfiniteScrollState;
        }
        root.removeAttribute('data-infinite-scroll-initialized');
      }
    };

    root._muheyyaInfiniteScrollState = state;
    observer.observe(status);
  }

  function scan() {
    scanScheduled = false;
    document.querySelectorAll(ROOT_SELECTOR).forEach(initialize);
  }

  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    window.requestAnimationFrame(scan);
  }

  addStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  [
    'collection:reloaded',
    'ajaxProduct:loaded',
    'ajaxProduct:updated',
    'theme:collection:reloaded',
    'shopify:section:load',
    'shopify:section:reorder'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleScan);
  });
  window.addEventListener('popstate', scheduleScan);

  new MutationObserver(scheduleScan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
